import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api, errMsg, TOKEN_KEY } from "@/lib/api";
import { useLogo } from "@/lib/store";

export default function AdminLogin() {
  const LOGO = useLogo();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (localStorage.getItem(TOKEN_KEY)) return <Navigate to="/admin/orders" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, r.data.token);
      nav("/admin/orders");
    } catch (x) {
      setErr(errMsg(x, "Sign in failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0e] grid place-items-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white p-8 sm:p-10 rise" data-testid="admin-login-form">
        <img src={LOGO} alt="Vinyl Record Vault" className="h-10 mx-auto" />
        <h1 className="font-head font-extrabold text-2xl text-center mt-8">Back office</h1>
        <p className="text-center text-xs text-zinc-500 mt-1">Sign in to manage the vault</p>
        <label className="block mt-8">
          <span className="label-caps text-[10px] text-zinc-500">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username"
            className="mt-1.5 w-full h-11 px-3 border border-zinc-300 outline-none focus:border-black" data-testid="admin-login-email" />
        </label>
        <label className="block mt-4">
          <span className="label-caps text-[10px] text-zinc-500">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
            className="mt-1.5 w-full h-11 px-3 border border-zinc-300 outline-none focus:border-black" data-testid="admin-login-password" />
        </label>
        {err && <p className="text-sm text-red mt-4" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="mt-6 w-full h-12 bg-red text-white font-bold text-xs tracking-[0.2em] hover:bg-[#b8161c] disabled:opacity-50 transition-colors" data-testid="admin-login-submit">
          {busy ? "SIGNING IN…" : "SIGN IN"}
        </button>
      </form>
    </div>
  );
}
